import type {RutaProd} from '../../../../runtime/rutas';
export default {
  "ruta": "/sistema/licencia-suspendida",
  "alias": [],
  "documento": "raiz",
  "acceso": "autenticado",
  "filas": [
    "158"
  ],
  "cita": "Controllers/LicenciaSuspendidaController.cs"
} satisfies RutaProd;
